import axios from "axios";

interface IDownloadBookingAttachmentReturn {
    file: any,
    fileName: string
}

export const downloadBookingAttachment = async (id: string): Promise<IDownloadBookingAttachmentReturn> => {
    const response = await axios.get(
        `/booking/attachment/${id}`,
        {
            responseType: 'blob'
        }
    );
    const contentDisposition = response.headers['content-disposition'];
    const fileName = contentDisposition.match(/filename="(.*)"/)?.[1] ?? 'unknown';
    return {
        file: response.data,
        fileName
    };
};

export default downloadBookingAttachment;